import { CategoryColor } from '@models/TagCategory.model';
import { getDefaultTagColor } from './getDefaultTagColor';

export function getDefaultTagBackground(
  background?: CategoryColor | undefined,
) {
  /** Prevent loop when we have default tag color */
  if (background !== getDefaultTagColor())
    return background || CategoryColor.UNCATEGORIZED;

  return CategoryColor.UNCATEGORIZED;
}
